import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export default class StepIndicator extends React.Component {
    getStepElements(currentStep, totalSteps) {
        var stepElements = [];
        var classes;

        for (var i = 1; i <= totalSteps; i++) {
            classes = classNames({
                'step-indicator__item': true,
                'step-indicator__item--active': i === currentStep,
            });

            stepElements.push(<div className={classes} key={i} />);
        }

        return stepElements;
    }

    render() {
        var classes = classNames({
            'step-indicator': true,
            'step-indicator--small': this.props.size === 'small',
        });

        return (
            <div className={classes}>
                {this.getStepElements(this.props.currentStep, this.props.totalSteps)}
            </div>
        );
    }
}

StepIndicator.propTypes = {
    totalSteps: PropTypes.number,
    currentStep: PropTypes.number,
    size: PropTypes.oneOf(['small', 'normal']),
};

StepIndicator.defaultProps = {
    totalSteps: 0,
    currentStep: 0,
    size: 'normal',
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/StepIndicator.jsx